module.exports = __webpack_public_path__ + "img/image10.418d0230.jpg";